import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import type { CampaignJoinResult, CampaignLinkPreview } from '../types/campaign'

import { api } from '@/shared/services/api'

export function useCampaignJoinFlow(code: string, options?: { enabled?: boolean }) {
  const enabled = (options?.enabled ?? true) && code.trim().length > 0
  const queryClient = useQueryClient()

  const previewQuery = useQuery({
    queryKey: ['/user/campaign_links', code],
    queryFn: async () => {
      const { data } = await api.get<{ record: CampaignLinkPreview }>(
        `/user/campaign_links/${code}`
      )
      return data.record
    },
    enabled,
    retry: false
  })

  const joinMutation = useMutation({
    mutationFn: async () => {
      const { data } = await api.post<{ record: CampaignJoinResult }>(
        '/user/campaigns/join',
        { code }
      )
      return data.record
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/user/campaigns'] })
    }
  })

  return { previewQuery, joinMutation }
}
